import { AfterViewInit, Component, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { SupportService } from '../../../services/support.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

export interface UserCaseData {
    id: string;
    caseNumber: string;
    status: string,
    subject: string,
    analyst: string;
    owner: string;
    date: string;

}

@Component({
  selector: 'app-support-cases',
  templateUrl: './support-cases.component.html',
  styleUrls: ['./support-cases.component.scss']
})
export class SupportCasesComponent implements AfterViewInit {


    displayedColumns: string[] = ['case', 'owner', 'date'];
    dataSource: MatTableDataSource<UserCaseData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    activeCases: Array<UserCaseData> = [];

    loadingMessage: string = "Loading...";

    isLoading: boolean = true;

    pagecode: string = "supp-all-cases";
    module: string = "support";

    accessdenied: boolean = false;


    constructor(private _router: Router,
        private authentication: AuthenticationService,
        private common: CommonService,
        private supportService: SupportService, private route: ActivatedRoute) {

        this.dataSource = new MatTableDataSource(this.activeCases);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        this.getUserCases(1);


                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );


        });
    }
    casesStatus: any = [
        {
            "name": "All",
            "code": "all",
            "isActive": true,
            "active_background_color": "#00a6b6",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "#00a6b6"
        },
        {
            "name": "Open",
            "code": "open",
            "isActive": false,
            "active_background_color": "green",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "green"
        },
        {
            "name": "On Hold",
            "code": "onhold",
            "isActive": false,
            "active_background_color": "orange",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "orange"
        },
        {
            "name": "Escalated",
            "code": "escalated",
            "isActive": false,
            "active_background_color": "red",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "red"
        },
        {
            "name": "Closed",
            "code": "closed",
            "isActive": false,
            "active_background_color": "grey",
            "active_color": "white",
            "inactive_background_color": "white",
            "inactive_color": "grey"
        }

    ];
    clickedRows(row: any) {
        this._router.navigate(['support/support-case-details/' + row.id]);
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    applyStatusFilter(statusCode: any) {
        if (statusCode === 'all') {
            this.dataSource = new MatTableDataSource(this.activeCases);
        }
        else if (statusCode == 'open') {
            var filteredArray: UserCaseData[] = this.activeCases.filter(s => s.status == 'Open');
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'closed') {
            var filteredArray: UserCaseData[] = this.activeCases.filter(s => s.status.toLowerCase().includes('closed'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'onhold') {
            var filteredArray: UserCaseData[] = this.activeCases.filter(s => s.status.toLowerCase().includes('hold'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }
        else if (statusCode == 'escalated') {
            var filteredArray: UserCaseData[] = this.activeCases.filter(s => s.status.toLowerCase().includes('escalated'));
            this.dataSource = new MatTableDataSource(filteredArray);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        for (var i = 0; i < this.casesStatus.length; i++) {
            if (this.casesStatus[i].code === statusCode)
                this.casesStatus[i].isActive = true;
            else
                this.casesStatus[i].isActive = false;
        }

    }
    splitText(text: any): string {
        if (text.length > 50)
            return text.substring(0, 50) + "...";
        else
            return text;
    }

    getUserCases(page: any) {

        this.supportService.getUserCasses(this.authentication._authentication.id, page).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {


                        for (var i = 0; i < res.data.length; i++) {
                            this.activeCases.push({
                                id: res.data[i].Id,
                                caseNumber: res.data[i].CaseNumber,
                                status: res.data[i].Status,
                                subject: res.data[i].Subject,
                                analyst: res.data[i].Owner.Name,
                                owner: res.data[i].Contact.Name,
                                date: res.data[i].LastModifiedDate
                            });
                        }
                        this.dataSource = new MatTableDataSource(this.activeCases);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                        this.loadingMessage = "No cases found";
                        //console.log('_userCasses', this.activeCases);

                        if (res.data.length > 0)
                            this.getUserCases(page + 1);
                    }
                    else
                        this.isLoading = false;
                }
                else {
                    this.common.ShowMessage("error", res.error_message, '');
                    this.isLoading = false;
                }

            },
            (err: any) => {
                console.error('Web/Support/Dashboard/getUserCases()', err);
            }
        );
    }

}
